import { useId } from "react";

/** The mark of «Спираль»: three rings of the path cut by a V, the diamond-milestone in the centre. Colours are the theme's tokens
 * (--path, --mark), so the mark follows light and dark; `mono` draws it in the current text colour. */
export function BrandMark({ size = 32, mono = false, className }: { size?: number; mono?: boolean; className?: string }) {
  const mask = `vekha-v-${useId().replace(/[^a-z0-9]/giu, "")}`;
  const ring = mono ? "currentColor" : "var(--path)";
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 64 64" aria-hidden="true" focusable="false">
      <defs>
        <mask id={mask} maskUnits="userSpaceOnUse" x="0" y="0" width="64" height="64">
          <rect width="64" height="64" fill="#fff" />
          <path d="M32 36.65L-11.17 -27.35L75.17 -27.35Z" fill="#000" />
        </mask>
      </defs>
      <g mask={`url(#${mask})`} fill="none" stroke={ring} strokeWidth="6">
        <circle cx="32" cy="32" r="26" strokeOpacity={mono ? 1 : 0.36} />
        <circle cx="32" cy="32" r="18" strokeOpacity={mono ? 1 : 0.66} />
        <circle cx="32" cy="32" r="10" />
      </g>
      <path d="M32 26.4L37.6 32L32 37.6L26.4 32Z" fill={mono ? "currentColor" : "var(--mark)"} />
    </svg>
  );
}

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`brand ${compact ? "brand--compact" : ""}`.trim()}>
      <BrandMark className="brand__mark" size={compact ? 32 : 36} />
      <span className="brand__copy">
        <strong>{import.meta.env.VITE_VEKHA_BETA === "true" ? "Веха · бета" : "Веха"}</strong>
        {compact ? null : <small>Академия гипнотерапии</small>}
      </span>
    </div>
  );
}
